import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  styled,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { CopyAllOutlined, DeleteOutline } from "@mui/icons-material";
import { statusStyleArray } from "../config";
import {
  formattedAmountWithoutAed,
  getImageSrc,
} from "../../../utils/CommonFunction";
import { useNavigate } from "react-router-dom";
import ConfirmModel from "../../../components/ConfirmModel";
import { ReactComponent as SmallDhiramIcon } from "../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../utils/CurrencyUtils";
import { ReactComponent as Dots } from "../../../assets/svg/Action.svg";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;

  const displayText = text
    .replace(/-/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return displayText;
};

const StyledTableCell = styled(TableCell)(() => ({
  borderBottom: "none",
}));

const ActiveStyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  display: "flex",
  alignItems: "center",
  gap: "7px",
  marginTop: "13px",
}));

export default function PackageDetails({
  details,
  handleDelete,
  handleSubmitClone,
  selectedTab,
}) {
  const navigate = useNavigate();
  const handleChange = (item) => {
    // navigate("/edit-package", {
    //   state: { item, status: "submitted" },
    // });
    navigate(`/new-create-package/${item?.id}`);
  };

  const handleChange2 = (item) => {
    console.log("called", item);
    navigate(`/package/details/${item?.id}`);
  };

  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [cloneData, setCloneData] = useState(null);
  const [cloneName, setCloneName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuItem, setMenuItem] = useState(null);

  const handleClone = (item) => {
    setCloneData(item);
    setCloneName(`Copy - ${item.name}`);
    setCloneDialogOpen(true);
  };

  const handleCloneSave = async () => {
    if (cloneData) {
      await handleSubmitClone(cloneData.id);
    }
    setCloneDialogOpen(false);
  };
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "none !important",
          boxShadow: "none",
          maxHeight: "80vh",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },

            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },

              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Package ID</StyledTableCell>
              <StyledTableCell sx={{ width: "25%", fontWeight: "bold" }}>
                Package Name
              </StyledTableCell>
              <StyledTableCell>Budget Type</StyledTableCell>
              <StyledTableCell>Timeline</StyledTableCell>
              <StyledTableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              {(selectedTab === 4 || selectedTab === 0) && (
                <StyledTableCell>Active</StyledTableCell>
              )}

              <StyledTableCell>Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details?.map((item, idx) => (
              <TableRow key={item.id}>
                <StyledTableCell>{item?.id}</StyledTableCell>
                <StyledTableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    onClick={() => handleChange2(item)}
                    sx={{
                      flexWrap: "wrap",
                      flex: 1,
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      component="img"
                      src={getImageSrc(item?.image?.path)}
                      alt="Package Icon"
                      sx={{
                        width: 45,
                        height: 45,
                        borderRadius: "8px",
                        border: "2px solid white",
                        boxShadow: "0px 4px 2.67px 0px #00000026",
                        marginRight: 1,
                        flexShrink: 0,
                      }}
                    />
                    <div>
                      <Typography
                        sx={{
                          flex: 1,
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          fontSize: "14px",
                          fontWeight: "500",
                          transition: "color 0.3s",
                          "&:hover": {
                            color: "blue",
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        sx={{
                          flex: 1,
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 1,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          fontSize: "14px",
                          fontWeight: "500",
                          transition: "color 0.3s",
                          color: "#949DAA",
                        }}
                      >
                        {item.projectType}
                      </Typography>
                    </div>
                  </Box>
                </StyledTableCell>
                <StyledTableCell>
                  <Typography
                    style={{
                      borderRadius: "34px",
                      padding: "4px 8px",
                      fontSize: "14px",
                      minWidth: "7ch",
                      width: "fit-content",
                      backgroundColor:
                        statusStyleArray.find(
                          (style) =>
                            style.status.toLowerCase() ===
                            item?.budgetType.toLowerCase()
                        )?.backgroundColor || "transparent",
                      color:
                        statusStyleArray.find(
                          (style) =>
                            style.status.toLowerCase() ===
                            item?.budgetType.toLowerCase()
                        )?.color || "black",
                      border: "none",
                    }}
                  >
                    {getStatusDisplayText(item?.budgetType)}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  {item?.timeline}
                </StyledTableCell>
                <StyledTableCell sx={{ textAlign: "right" }}>
                  {item?.cost ? formattedAmountWithoutAed(item?.cost) : '-'}
                </StyledTableCell>
                <StyledTableCell>
                  {/* <Typography
                    style={{
                      borderRadius: "34px",
                      padding: "4px 8px",
                      fontSize: "14px",
                      minWidth: "7ch",
                      width: "fit-content",
                      backgroundColor:
                        statusStyleArray.find(
                          (style) => style.status === item?.status
                        )?.backgroundColor || "transparent",
                      color:
                        statusStyleArray.find(
                          (style) => style.status === item?.status
                        )?.color || "black",
                      border: "none",
                      textAlign: "center",
                    }}
                  >
                    {getStatusDisplayText(
                      item?.status === "CREATED" ? "DRAFT" : item?.status
                    )}
                  </Typography> */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        width: "15px",
                        height: "15px",
                        borderRadius: "50%",
                        backgroundColor:
                          statusStyleArray.find(
                            (style) => style.status === item?.status
                          )?.backgroundColor || "transparent",
                        border: "3px solid #e5e5e5",
                      }}
                    />
                    <Typography
                      style={{
                        fontSize: "14px",
                        marginLeft: "8px",
                        color: "#0D0D0E",
                      }}
                    >
                      {getStatusDisplayText(
                        item?.status.toLowerCase() === "CREATED"
                          ? "DRAFT"
                          : item?.status.toLowerCase()
                      )}
                    </Typography>
                  </div>
                </StyledTableCell>

                {(selectedTab === 4 || selectedTab === 0) && (
                  <ActiveStyledTableCell>
                    {item?.status === "approved" ? (
                      <>
                        <div
                          style={{
                            width: "15px",
                            height: "15px",
                            borderRadius: "50%",
                            backgroundColor: item?.isActive
                              ? "#4BB34B"
                              : "#E54746",
                            border: "3px solid #e5e5e5",
                          }}
                        ></div>
                        <div>{item?.isActive ? "ON" : "OFF"}</div>
                      </>
                    ) : (
                      "-"
                    )}
                  </ActiveStyledTableCell>
                )}

                <StyledTableCell>
                  <IconButton
                    size="small"
                    title="Actions"
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                      setMenuItem(item);
                    }}
                  >
                    <Dots fontSize="20" />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => {
                      setAnchorEl(null);
                      setMenuItem(null);
                    }}
                    PaperProps={{
                      sx: {
                        boxShadow: "none", // remove default shadow
                        padding: "6px 4px", // add inner padding
                        borderRadius: "8px",
                        minWidth: "100px",
                        border: "1px solid #E5E5E5", // add border
                      },
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        handleChange(menuItem);
                        setAnchorEl(null);
                      }}
                      sx={{ color: "#4D6BF6", mb: 0.5, mt: 0.5 }} // blue for Edit
                    >

                      Edit
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        handleDelete(menuItem?.id);
                        setAnchorEl(null);
                      }}
                      sx={{ color: "#D64B64", mb: 0.5 }} // red for Delete
                    >
                      Delete
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        handleClone(menuItem);
                        setAnchorEl(null);
                      }}
                      sx={{ color: "rgb(13, 13, 14)", mb: 0.5 }} // optional: blue for Clone
                    >
                      Clone
                    </MenuItem>
                  </Menu>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ConfirmModel
        visible={cloneDialogOpen}
        handleClose={() => setCloneDialogOpen(false)}
        confirmation={() => {
          handleCloneSave();
        }}
        message={
          <>
            <p>Are you sure you want to clone this package?</p>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ flexWrap: "wrap", flex: 1, marginTop: "1vh" }}
            >
              <Box
                component="img"
                src={getImageSrc(cloneData?.image?.path)}
                alt="Package Icon"
                sx={{
                  width: 45,
                  height: 45,
                  borderRadius: "8px",
                  border: "2px solid white",
                  boxShadow: "0px 4px 2.67px 0px #00000026",
                  marginRight: 1,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {cloneData?.name}
              </Typography>
            </Box>
          </>
        }
      />
    </>
  );
}
